import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <h1 className="text-3xl font-semibold text-[--gray-900] mb-2">Page not found</h1>
        <p className="text-[--gray-600] mb-6">The page you’re looking for doesn’t exist.</p>
        <div className="flex gap-3 justify-center">
          <Link to="/" className="px-4 py-2 rounded-md bg-brand-600 text-white hover:bg-brand-700">Go to Home</Link>
        </div>
      </div>
    </div>
  )
}


